<template>
  <!-- 工作日志流程详情 -->
  <div class="details-box">
    <div class="title">
      工作日志审批进度（ {{details.Code}} ）
    </div>
    <div v-if="JSON.stringify(details) != '{}'">
      <sub-title title="日志信息"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              企业名称：
            </div>
            <div class="item-right">
              {{details.CompanyName}}
            </div>
          </div>
          <div class="details-box-item" style="width:66%">
            <div class="item-left">
              企业地址：
            </div>
            <div class="item-right">
              <span v-for="(item,i) in details.Addrs" :key="i">
                <span>{{item.Address}}</span>
                <span v-if="!(i===details.Addrs.length-1)">、</span>
              </span>
            </div>
          </div>
        </div>
        <div v-for="(item,i) in details.Contacts" :key="i">
          <div class="details-box-item" style="border:none">
            <div class="details-box-item">
              <div class="item-left">
                联系人：
              </div>
              <div class="item-right">
                {{item.Name}}
              </div>
            </div>
            <div class="details-box-item">
              <div class="item-left">
                联系人职位：
              </div>
              <div class="item-right">
                {{item.JobTitle}}
              </div>
            </div>
            <div class="details-box-item">
              <div class="item-left">
                联系人电话：
              </div>
              <div class="item-right">
                {{item.Tel}}
              </div>
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              合作价格：
            </div>
            <div class="item-right">
              {{details.CooperationPrice}}元
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              企业最高资质：
            </div>
            <div class="item-right">
              {{details.HighestQualification}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              合作担保公司：
            </div>
            <div class="item-right">
              {{details.CooperationCompanies}}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              客户来源：
            </div>
            <div class="item-right">
              {{details.SourceFrom}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              经营模式：
            </div>
            <div class="item-right">
              {{details.OperationWay}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              营销模式：
            </div>
            <div class="item-right">
              {{details.SaleWay}}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              初次跟进：
            </div>
            <div class="item-right">
              {{details.IsFirstTimeContact ? '是' : '否'}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              是否合作：
            </div>
            <div class="item-right">
              {{details.IsCooperation ? '是' : '否'}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              备注：
            </div>
            <div class="item-right">
              {{details.Memo}}
            </div>
          </div>
        </div>
      </div>
      <!-- 流程图 -->
      <flow-chart :details="processData" :selTab="type" :TemplateID="TemplateID" @close="$emit('refresh')" v-if="JSON.stringify(processData)!='{}'"></flow-chart>
    </div>
  </div>
</template>
<script>
import { WorkflowQuery } from "@/http/api";

export default {
  name: "JobLogProcessDetail",
  components: {},
  props: {
    ID: {       // 当前id
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ""
    },
    TemplateID: {    // 流程ID
      type: Number,
      default: null
    }
  },
  data() {
    return {
      processData: {},
      details: {}
    }
  },
  watch: {
    ID: {
      handler(val, oldVal) {
        this.getDetails();
      },
      immediate: true
    }
  },
  methods: {
    getDetails() {
      this.$emit('loading', true)
      WorkflowQuery({ workflowId: this.ID, templateId: this.TemplateID }, 'Get').then(res => {
        if (!!res && JSON.stringify(res) != "{}") {
          res.Worklog.Addrs = JSON.parse(res.Worklog.Addrs);
          this.details = res.Worklog;
          this.processData = res;
        };
        this.$emit('loading', false)
      })
    },
  }
}
</script>
<style scoped lang='less'>
@import "./details.less";
</style>